import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Chat } from '../interfaces/chat.type';
import { Files } from '../interfaces/file-manager.type';
import { Mail } from '../interfaces/mail.type';
import { createRequestBody } from '../util';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppsService {
    public resourceUrl = environment.SERVER_API_URL;
    constructor(private http: HttpClient) {}

    public getChatJSON(): Observable<Chat[]> {
        return this.http.get<Chat[]>('./assets/chat-data.json');
    }

    public getFileManagerJson(): Observable<Files[]> {
        return this.http.get<Files[]>('./assets/data/apps/file-manager-data.json');
    }

    public getMailJson(): Observable<Mail[]> {
        return this.http.get<Mail[]>('./assets/data/apps/mail-data.json');
    }

    public getProjectListJson(): Observable<any[]> {
        return this.http.get<any[]>('./assets/data/apps/project-list-data.json');
    }
    getResources() {
        return this.http.get(`${this.resourceUrl}api/res/all`, { observe: 'response' });
    }
    queryActiveFund(body?: any): Observable<any> {
        return this.http.post<any[]>(environment.SERVER_API_URL + 'api/active-product', body,  {  observe: 'response' });
    }
    getProductsMini(body: any) {
        return this.http.post(environment.SERVER_API_URL + 'api/product/list/mini', body);
    }
    getThirdAppList(req: any) {
        const options = createRequestBody(req);
        return this.http.post<any[]>(environment.SERVER_API_URL + 'api/thirdApp/list/', options , { observe: 'response' });
    }
}
